import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  FiChevronDown,
  FiChevronUp,
  FiCheck,
} from "react-icons/fi";
import {
  motion,
  AnimatePresence,
} from "framer-motion";

import { comparisonTable } from "../Data";
import tableDot from "../Images/table-dot.svg";

const leftVariant = {
  hidden: {
    opacity: 0,
    x: -60,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: .8,
      ease: [0.22,1,0.36,1],
    },
  },
};

const rightVariant = {
  hidden: {
    opacity: 0,
    x: 60,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: .8,
      ease: [0.22,1,0.36,1],
    },
  },
};

const tableVariant = {
  hidden: {
    opacity: 0,
    y: 70,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: .8,
      ease: [0.22,1,0.36,1],
    },
  },
};

const rowContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: .05,
    },
  },
};

const rowVariant = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: .35,
    },
  },
};

const PricingTable = () => {

  const [open, setOpen] = useState([1]);
  const [openSection, setOpenSection] = useState(0);

  const toggle = (id) => {
    setOpen((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  const renderValue = (value) => {

    if (value === "check")
      return (
        <motion.div
          initial={{
            scale: 0,
            rotate: -180,
          }}
          animate={{
            scale: 1,
            rotate: 0,
          }}
          transition={{
            duration: .35,
          }}
        >
          <FiCheck className="table-check" />
        </motion.div>
      );

    if (value === "-")
      return "-";

    return value;
  };

 const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          const y =
            element.getBoundingClientRect().top +
            window.pageYOffset -
            120; // Header height

          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }
      }, 100);
    }
  }, [location]);

  return (
    <section className="pricing-table-section container" id="compare-all-plans">

      <div className="pricing-table-top">

        <motion.div
          className="pricing-table-left"
          variants={leftVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h2 className="section-heading">
            Every feature, <span>side by side</span>
          </h2>
        </motion.div>

        <motion.div
          className="pricing-table-right"
          variants={rightVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p className="section-text">
            Compare what's included in each plan —
            from your first automated reply to
            full-scale automation.
          </p>
        </motion.div>

      </div>
<div className="comparison-table-wrapper">
      <motion.div
        className="comparison-table"
        variants={tableVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >

        {/* Header */}

        <div className="table-header">

          <div className="feature-column">
            <h3 className="card-heading special-heading">
              Compare Plans
            </h3>
          </div>

          <div className="plan-column">
            <h3 className="card-heading">
              Free Forever
            </h3>
            <p>₹0/mo</p>
          </div>

          <div className="plan-column">
            <h3 className="card-heading">
              Starter
            </h3>
            <p>₹1,199/mo</p>
          </div>

          <div className="plan-column pro">
            <h3 className="card-heading">
              Pro
            </h3>
            <p>₹2,999/mo</p>
          </div>

        </div>

        {comparisonTable.map((section) => (

          <motion.div
            key={section.id}
            className="table-group"
            initial={{
              opacity: 0,
              y: 40,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{ once: true }}
            transition={{
              duration: .5,
            }}
          >

            <motion.div
              className={`table-group-title ${
                open.includes(section.id)
                  ? "active"
                  : ""
              }`}
              onClick={() => toggle(section.id)}
              whileHover={{
                scale: 1.01,
              }}
            >

              <div className="table-title-left">

                <img
                  className="green-dot"
                  src={tableDot}
                  alt=""
                />

                <h3>
                  {section.title}
                </h3>

              </div>

              <motion.button
                animate={{
                  rotate: open.includes(section.id)
                    ? 180
                    : 0,
                }}
                transition={{
                  duration: .3,
                }}
              >
                {open.includes(section.id)
                  ? <FiChevronUp />
                  : <FiChevronDown />}
              </motion.button>

            </motion.div>

            <AnimatePresence initial={false}>

              {open.includes(section.id) && (

                <motion.div
                  className="table-body"
                  initial={{
                    height: 0,
                    opacity: 0,
                  }}
                  animate={{
                    height: "auto",
                    opacity: 1,
                  }}
                  exit={{
                    height: 0,
                    opacity: 0,
                  }}
                  transition={{
                    duration: .45,
                  }}
                  style={{
                    overflow: "hidden",
                  }}
                >

                  <motion.div
                    variants={rowContainer}
                    initial="hidden"
                    animate="visible"
                  >

                    {section.rows.map((row, i) => (

                      <motion.div
                        className="table-row"
                        key={i}
                        variants={rowVariant}
                        whileHover={{
                          backgroundColor:
                            "rgba(15,174,77,.04)",
                        }}
                      >

                        <div className="feature-column">
                          {row.feature}
                        </div>

                        {row.values.map((value, idx) => (

                          <div
                            key={idx}
                            className={`plan-column ${
                              idx === 2
                                ? "pro"
                                : ""
                            }`}
                          >
                            {renderValue(value)}
                          </div>

                        ))}

                      </motion.div>

                    ))}

                  </motion.div>
            

                </motion.div>
           

              )}

            </AnimatePresence>
               

          </motion.div>
      

        ))}

      </motion.div>
                  </div>

  <div className="pricing-mobile">

  {comparisonTable.map((section, index) => (

    <motion.div
      className={`pricing-mobile-card ${
        openSection === index ? "active" : ""
      }`}
      key={section.id}
      initial={{
        opacity: 0,
        y: 40,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{ once: true }}
      transition={{
        duration: 0.5,
        delay: index * 0.08,
      }}
    >

      <button
        className="pricing-mobile-header"
        onClick={() =>
          setOpenSection(
            openSection === index ? -1 : index
          )
        }
      >

        <h3>{section.title}</h3>

        <motion.div
          animate={{
            rotate: openSection === index ? 180 : 0,
          }}
          transition={{
            duration: 0.3,
          }}
        >
          {openSection === index
            ? <FiChevronUp />
            : <FiChevronDown />}
        </motion.div>

      </button>

      <AnimatePresence initial={false}>

        {openSection === index && (

          <motion.div
            className="pricing-mobile-body"
            initial={{
              height: 0,
              opacity: 0,
            }}
            animate={{
              height: "auto",
              opacity: 1,
            }}
            exit={{
              height: 0,
              opacity: 0,
            }}
            transition={{
              duration: 0.45,
            }}
            style={{
              overflow: "hidden",
            }}
          >

            <motion.div
              variants={rowContainer}
              initial="hidden"
              animate="visible"
            >

              <motion.div
                className="pricing-mobile-head"
                variants={rowVariant}
              >

                <span></span>

                <span>Free</span>

                <span>Starter</span>

                <span>Pro</span>

              </motion.div>

              {section.rows.map((row, i) => (

                <motion.div
                  className="pricing-mobile-row"
                  key={i}
                  variants={rowVariant}
                  whileHover={{
                    backgroundColor:
                      "rgba(15,174,77,.05)",
                  }}
                >

                  <span>{row.feature}</span>

                  <span>{renderValue(row.values[0])}</span>

                  <span>{renderValue(row.values[1])}</span>

                  <span>{renderValue(row.values[2])}</span>

                </motion.div>

              ))}

            </motion.div>

          </motion.div>

        )}

      </AnimatePresence>

    </motion.div>

  ))}

</div>
    </section>
  );
};

export default PricingTable;